const Text = {
    baseStyle: {},
    variants: {},
};

export default Text;
